import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import { logout } from '../store/slices/authSlice';
import { selectIsAuthenticated, selectCurrentUser, selectAuthLoading } from '../store/selectors/authSelectors';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const user = useAppSelector(selectCurrentUser);
  const isLoading = useAppSelector(selectAuthLoading);

  const handleLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  return {
    isAuthenticated,
    user,
    isLoading,
    logout: handleLogout,
  };
};